import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';
import queryString from 'query-string';

export interface Operator {
  id: string;
  name: string;
}

export const getOperators = async (signal?: AbortSignal): Promise<Operator[]> => {
  const res = await apiClient.get<{ data: Operator[] }>(`/filters/operators`, {
    signal,
    paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data.data;
};

interface UseOperatorsOptions<TData> {
  config?: QueryConfig<typeof getOperators, TData>;
}

export const useFilterOperators = <TData = Operator[]>({ config }: UseOperatorsOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 120 * 1000,
    ...config,
    queryFn: ({ signal }) => getOperators(signal),
    queryKey: ['filter-operators'],
  });
};
